import React, { useState, useEffect } from "react";

const presetRoles = {
  default: "You are an AI Assistant. Answer clearly based on uploaded documents. When answering, always include the source (file name and page number) for each point you make. Respond accordingly in Bahasa Indonesia.",
  trader: "You are a professional financial trading assistant specializing in gold (XAU/USD). You are a gold (XAU/USD) trading expert. Always try to give a trading entry strategy even if market data is incomplete. Mention clear entry, stop loss, and take profit levels.  Respond accordingly in Bahasa Indonesia.",
  stocks: "You are an AI Assistant specializing in analyzing stocks on the Indonesia Stock Exchange (IDX/BEI). Provide fundamental, technical, sentiment, and macroeconomic insights about Indonesian equities. Explain clearly in Bahasa Indonesia (or English if needed), keep it professional, concise, and objective. Highlight both risks and opportunities, but do not give personal investment advice.",
  formal: "Respond in a formal and analytical tone.",
};

const BotStyleSelector = ({ onSystemRoleChange }) => {
  const [botMode, setBotMode] = useState("preset"); // "preset" or "custom"
  const [selectedPreset, setSelectedPreset] = useState("default");
  const [customRole, setCustomRole] = useState("");

  useEffect(() => {
    if (botMode === "custom" && customRole.trim()) {
      onSystemRoleChange(customRole.trim());
    } else {
      onSystemRoleChange(presetRoles[selectedPreset]);
    }
  }, [botMode, selectedPreset, customRole, onSystemRoleChange]);

  return (
    <div className="space-y-4">

      <div className="flex flex-col space-y-2">
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="botMode"
            value="preset"
            checked={botMode === "preset"}
            onChange={() => setBotMode("preset")}
            className="form-radio text-blue-500"
          />
          <span className="ml-2">Use Preset</span>
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="botMode"
            value="custom"
            checked={botMode === "custom"}
            onChange={() => setBotMode("custom")}
            className="form-radio text-blue-500"
          />
          <span className="ml-2">Custom Role</span>
        </label>
      </div>

      {botMode === "preset" ? (
        <select
          value={selectedPreset}
          onChange={(e) => setSelectedPreset(e.target.value)}
          className="w-full p-2 rounded bg-gray-800 border border-gray-600 text-sm"
        >
          {Object.keys(presetRoles).map((key) => (
            <option key={key} value={key}>
              {key.charAt(0).toUpperCase() + key.slice(1)}
            </option>
          ))}
        </select>
      ) : (
        <textarea
          value={customRole}
          onChange={(e) => setCustomRole(e.target.value)}
          placeholder="Enter custom bot instruction here..."
          className="w-full p-2 rounded bg-gray-800 border border-gray-600 h-24 text-sm resize-none"
        />
      )}
    </div>
  );
};

export default BotStyleSelector;
